export default "__VITE_ASSET__lrCAa9xo__"